export default {
  APIBASEURL: process.env.VUE_APP_WALLET_API,
  APIWMASSURL: process.env.VUE_APP_SWAP_API,
  EXPLORERURL: 'https://massexplorer.org/',
  APIEXPLORERURL: 'https://api.massexplorer.org/'
}